import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function CompaniesCompanyPage(): React.ReactElement {
  const currentSecurity = useSecurity('Companies', 'Company');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Companies/Scripts/Resources/en/res.Company.en.js",
        "Areas/Companies/Scripts/Resources/en/Types.en.js",
        "Areas/Companies/Scripts/Enums.js",
        "Areas/Companies/Scripts/Company/Index.js"], "initCompaniesCompany", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
